import { useState, useEffect } from 'react';
import debounce from 'lodash.debounce';

const useResizeObserver = () => {
  const [dimensions, setDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const debouncedResizeHandler = debounce(() => {
      setDimensions({
        width: window.innerWidth || 0,
        height: window.innerHeight || 0,
      });
    }, 50);

    window.addEventListener('resize', debouncedResizeHandler);

    return () => window.removeEventListener('resize', debouncedResizeHandler);
  }, []);

  return { dimensions };
};

export default useResizeObserver;
